import api from "./configuration";
import apiUrl from "./url";
import store from "@/store";
// This client intentionally exposes GET operations only and captures the request identity.
export const createDsScoutingClient = () => {
	const token = store.getState().token;
	if (!token) throw Error("Sessione DS non disponibile.");
	const read = async (path, params) =>
		(
			await api.request({
				method: "GET",
				url: apiUrl + path,
				params,
				useAuthInterceptor: false,
				headers: {Authorization: `Bearer ${token}`},
			})
		).data;
	return {
		overview: async (seasonId, clubId) => {
			const [pipeline, reports, visions, rosters] = await Promise.all([
				read("/ScoutingPipeline", {seasonId}),
				read("/ScoutingReports", {seasonId}),
				read("/ScoutingVisions", {seasonId}),
				read("/Rosters", {seasonId, clubId, prospect: true}),
			]);
			if (![pipeline, reports, visions, rosters].every(Array.isArray))
				throw Error("Fonti scouting non leggibili.");
			if (pipeline.some((row) => !row.player || row.player.id !== row.playerId))
				throw Error("Candidati della pipeline non disponibili.");
			return {
				pipeline,
				reports,
				visions,
				rosters: rosters.filter(
					(r) => r.prospect === true && r.clubId === clubId,
				),
			};
		},
		profile: (id) => read(`/Players/${id}/ai-profile`),
		indices: (id, season) =>
			read(`/Players/${id}/provider-matches/indices`, {
				season,
				officialOnly: true,
			}),
		lineup: async (id) => {
			const [lineup, members] = await Promise.all([
				read(`/Rosters/${id}/lineup`),
				read(`/Rosters/${id}/players`),
			]);
			if (!lineup || !Array.isArray(members))
				throw Error("Schieramento non disponibile.");
			return {lineup, members};
		},
		visions: (id) => read(`/Matches/${id}/visions`),
	};
};
